// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComponentSelector-module__componentInfo--Isix1{color:blue}`, "",{"version":3,"sources":["webpack://./src/components/ComponentViewer/ComponentSelector/ComponentSelector.module.css"],"names":[],"mappings":"AAAA,gDACE,UAAA","sourcesContent":[".componentInfo {\n  color: blue\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"componentInfo": `ComponentSelector-module__componentInfo--Isix1`
};
export default ___CSS_LOADER_EXPORT___;
